export default __webpack_public_path__ + "static/media/driver-infected.8f9a10f9.svg";